import { Controller } from "@hotwired/stimulus"

// Uses the issue deadline so failed attempts do not restart the countdown
// and hides the timer label. No-op if elements are missing.
export default class extends Controller {
  static targets = ["label", "counter", "button"]
  static values = { until: String }

  connect() {
    this.tick()
    if (this.remaining > 0) this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  tick() {
    this.remaining = Math.max(0, Math.ceil((Date.parse(this.untilValue) - Date.now()) / 1000))
    if (this.hasCounterTarget) this.counterTarget.textContent = this.remaining
    if (this.remaining <= 0 || !Number.isFinite(this.remaining)) {
      this.enableResend()
    } else {
      if (this.hasLabelTarget) this.labelTarget.classList.remove("hidden")
      if (this.hasButtonTarget) this.buttonTarget.classList.add("hidden")
    }
  }

  enableResend() {
    clearInterval(this.interval)
    if (this.hasLabelTarget) this.labelTarget.classList.add("hidden")
    if (this.hasButtonTarget) this.buttonTarget.classList.remove("hidden")
  }
}
